import React from "react";
import {markers} from '../../libs/config';

class MapMarkerLegends extends React.Component {

  render() {
    return (
      <table style={{width: '100%'}}>
        <tbody>
        <tr className="markers_legend">
          <td className="markers_legend_item">
            <img src={markers.steady_waterlevel} alt="not found"/>
            <p>Below Warning Level and Steady</p>
          </td>
          <td className="markers_legend_item">
            <img src={markers.warning_steady_waterlevel} alt="not found"/>
              <p>Above Warning Level and Steady</p>
            </td>
            <td className="markers_legend_item">
              <img src={markers.danger_steady_waterlevel} alt="not found"/>
              <p>Above Danger Level and Steady</p>
            </td>
          </tr>
          <tr className="markers_legend">
            <td className="markers_legend_item">
              <img src={markers.rising_waterlevel} alt="not found"/>
              <p>Below Warning Level and Rising</p>
            </td>
            <td className="markers_legend_item">
              <img src={markers.warning_rising_waterlevel} alt="not found"/>
              <p>Above Warning Level and Rising</p>
            </td>
            <td className="markers_legend_item">
              <img src={markers.danger_rising_waterlevel} alt="not found"/>
              <p>Above Danger Level and Rising</p>
            </td>
          </tr>
          <tr className="markers_legend">
            <td className="markers_legend_item">
              <img src={markers.falling_waterlevel} alt="not found"/>
              <p>Below Warning Level and Falling</p>
            </td>
            <td className="markers_legend_item">
              <img src={markers.warning_falling_waterlevel} alt="not found"/>
              <p>Above Warning Level and Falling</p>
            </td>
            <td className="markers_legend_item">
              <img src={markers.danger_falling_waterlevel} alt="not found"/>
              <p>Above Danger Level and Falling</p>
            </td>
          </tr>
          </tbody>
        </table>
    );
  }
}

export default MapMarkerLegends;



// WEBPACK FOOTER //
// ./src/components/Home/MapMarkerLegends.js